import { render, staticRenderFns } from "./plan-status-popup.html?vue&type=template&id=c968fda0&scoped=true&external"
import script from "./plan-status-popup.js?vue&type=script&lang=js&external"
export * from "./plan-status-popup.js?vue&type=script&lang=js&external"
import style0 from "./plan-status-popup.scss?vue&type=style&index=0&id=c968fda0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c968fda0",
  null
  
)

export default component.exports